import styled from 'styled-components';
import MockUser from '../../assets/img/avatar.jpg';
import MockUserInner from '../../assets/img/avatar_inner.jpg';

export const UserAvatar = styled.div`
  position: relative;
  
  width: 64px;
  height: 64px;
  margin-right: 15px;
  
  font-size: 0;
  
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    
    object-fit: cover;
    
    &::after {
      content: "";
      
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      
      width: 100%;
      height: 100%;
      
      border-radius: 50%;
      background: transparent no-repeat center / contain;
      background-image: ${({ isInnerPage }) => `url(${isInnerPage ? MockUserInner : MockUser})`};
    }
  }
`;

export const UserWrapper = styled.div``;

export const UserStatus = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
`;

export const UserName = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
  
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
`;

export const UserChange = styled.label`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  
  background-color: transparent;
  border: none;
  
  transition: color 0.3s;
  cursor: pointer;
  
  &:hover {
    color: ${({ theme }) => theme.black};
  }
`;

export const RemoveAvatar = styled.button`
  margin: 0;
  margin-left: 5px;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.red};
  
  background-color: transparent;
  border: none;
  
  transition: color 0.3s;
  cursor: pointer;
  
  &:hover {
    color: ${({ theme }) => theme.black};
  }
`;
